/**
 * Shared comparators for client-side list ordering.
 *
 * Catalog *products* arrive already ordered by the backend (drug name, then
 * numeric strength — see `catalog_sort_key` in
 * backend/app/services/catalog_product.py), so components should preserve
 * that order. Category headers are derived client-side and sorted here.
 */

export const UNCATEGORIZED_LABEL = 'Uncategorized'

/**
 * Sort category names alphabetically (locale-aware), with "Uncategorized"
 * always last.
 */
export function compareCategories(a: string, b: string): number {
  if (a === b) return 0
  if (a === UNCATEGORIZED_LABEL) return 1
  if (b === UNCATEGORIZED_LABEL) return -1
  return a.localeCompare(b)
}
